module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade modal-map-legend",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n        Map legend\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('ul', {
    staticClass: "map-legend"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.userIsNotClient) ? _c('li', [_c('img', {
    attrs: {
      "src": require("assets/img/Asset 2.png"),
      "alt": ""
    }
  }), _vm._v("\n            Carrier Trucks\n          ")]) : _vm._e(), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("assets/img/Asset 9.png"),
      "alt": ""
    }
  }), _vm._v("\n            " + _vm._s(_vm.userIsNotClient ? 'Other Trucks' : 'Trucks') + "\n          ")])])]), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('img', {
    attrs: {
      "src": require("assets/img/Asset 4.png"),
      "alt": ""
    }
  }), _vm._v("\n            Active Jobs\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('img', {
    attrs: {
      "src": require("assets/img/Asset 10.png"),
      "alt": ""
    }
  }), _vm._v("\n            Job Requests\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 footer-left"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 footer-right"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-73162d9b"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/LegendModal.vue
// module id = 1040
// module chunks = 0